import styled from 'styled-components';
import Heading from 'components/mediabay-ui/components/Heading';

const PageTitle = styled(Heading)`
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding-left: 20px;

  @media ( min-width: 768px ) {
    margin-top: 30px;
    padding-left: 60px;
  }
`;

export default PageTitle;
